export const FooterLinksCategory: string = 'Footer links';
export const FooterClickedAction: string = 'Footer links: Clicked';
